(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-product-showcase')) {
    customElements.define('brand-product-showcase', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (!this.slides.length) return;
        this.dots = [...this.querySelectorAll('[data-index]')];
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 5000;
        this.enabled = this.dataset.autoplay === 'true';
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.reduced.matches;
        this.editorPaused = false;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.controller = new AbortController();
        const on = (node, type, fn) => node?.addEventListener(type, fn, { signal: this.controller.signal });
        on(this.querySelector('[data-prev]'), 'click', () => this.go(this.index - 1, true));
        on(this.querySelector('[data-next]'), 'click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, index) => on(dot, 'click', () => this.go(index, true)));
        on(this.querySelector('[data-pause]'), 'click', () => { this.userPaused = !this.userPaused; this.updatePause(); this.schedule(); });
        on(this, 'pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
        on(this, 'pointerleave', e => { if (e.pointerType === 'mouse') { this.hovered = false; this.schedule(); } });
        on(this, 'focusin', () => { this.focused = true; this.schedule(); });
        on(this, 'focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.schedule(); } });
        on(this, 'keydown', e => {
          if (!e.target.closest('.bsc__controls, .bsc__arrow')) return;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1), true); this.dots[this.index]?.focus(); }
        });
        on(this, 'pointerdown', e => { this.touch = e.pointerType === 'touch' ? { x: e.clientX, y: e.clientY } : null; });
        on(this, 'pointerup', e => {
          if (!this.touch) return;
          const dx = e.clientX - this.touch.x, dy = e.clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1), true);
        });
        on(this, 'pointercancel', () => { this.touch = null; });
        on(document, 'visibilitychange', () => this.schedule());
        on(this.reduced, 'change', () => { this.userPaused = this.reduced.matches; this.updatePause(); this.schedule(); });
        on(document, 'shopify:block:select', e => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
          if (index >= 0) { this.editorPaused = true; this.go(index); }
        });
        on(document, 'shopify:block:deselect', e => { if (this.slides.some(slide => slide.dataset.blockId === e.detail.blockId)) { this.editorPaused = false; this.schedule(); } });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.05 });
          this.observer.observe(this);
        } else { this.visible = true; }
        this.classList.add('is-ready');
        this.go(0);
        this.updatePause();
      }
      go(index, announce = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { const active = i === this.index; slide.classList.toggle('is-active', active); slide.inert = !active; slide.setAttribute('aria-hidden', String(!active)); });
        this.dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === this.index); if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        if (announce) { const status = this.querySelector('[data-status]'); if (status) status.textContent = `${this.index + 1} / ${this.slides.length}: ${this.slides[this.index].querySelector('h2')?.textContent || ''}`; }
        this.schedule();
      }
      updatePause() {
        const button = this.querySelector('[data-pause]');
        if (!button) return;
        button.setAttribute('aria-label', this.userPaused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.querySelector('[data-pause-icon]').textContent = this.userPaused ? '▶' : 'Ⅱ';
      }
      schedule() {
        clearTimeout(this.timer);
        this.classList.remove('is-timing');
        if (this.slides.length < 2 || !this.enabled || this.userPaused || this.editorPaused || this.hovered || this.focused || !this.visible || document.hidden) return;
        void this.offsetWidth;
        this.classList.add('is-timing');
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-video-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-video-feature')) {
    customElements.define('brand-video-feature', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.controller = new AbortController();
        const on = (target, event, fn) => target.addEventListener(event, fn, { signal: this.controller.signal });
        this.mobile = matchMedia('(max-width: 767px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.near = false;
        this.visible = false;
        this.userPaused = false;
        this.manual = false;
        this.button = this.querySelector('[data-toggle]');
        this.status = this.querySelector('[data-status]');
        this.video.muted = true;
        on(this.button, 'click', () => {
          if (!this.video.paused) { this.userPaused = true; this.manual = false; this.video.pause(); }
          else { this.userPaused = false; this.manual = true; this.near = true; this.loadSource(); this.play(); }
        });
        on(this.video, 'play', () => {
          this.userPaused = false; this.manual = true;
          this.classList.add('is-playing'); this.button.setAttribute('aria-label', this.button.dataset.pauseLabel);
          this.status.textContent = '';
        });
        on(this.video, 'pause', () => {
          this.classList.remove('is-playing'); this.button.setAttribute('aria-label', this.button.dataset.playLabel);
          if (this.video.controls && this.visible && !document.hidden && !this.switching) { this.userPaused = true; this.manual = false; }
        });
        on(this.video, 'ended', () => { this.userPaused = true; this.manual = false; });
        on(this.video, 'error', () => { if (this.video.getAttribute('src')) this.status.textContent = this.status.dataset.error; });
        on(this.video, 'loadedmetadata', () => { this.switching = false; this.syncPlayback(); });
        on(this.mobile, 'change', () => { if (this.near) { this.loadSource(); this.syncPlayback(); } });
        on(this.reduced, 'change', () => { this.manual = false; this.syncPlayback(); });
        on(document, 'visibilitychange', () => this.syncPlayback());
        if ('IntersectionObserver' in window) {
          this.loader = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) { this.near = true; this.loadSource(); this.loader.disconnect(); }
          }, { rootMargin: '250px 0px', threshold: 0 });
          this.loader.observe(this);
          this.visibility = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
            this.syncPlayback();
          }, { threshold: [0, 0.1] });
          this.visibility.observe(this.video);
        } else { this.near = true; this.visible = true; this.loadSource(); this.syncPlayback(); }
      }
      loadSource() {
        if (!this.near) return;
        const source = this.mobile.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
        const poster = this.mobile.matches ? this.dataset.mobilePoster : this.dataset.desktopPoster;
        if (poster) this.video.poster = poster;
        else this.video.removeAttribute('poster');
        if (!source || source === this.video.getAttribute('src')) return;
        this.switching = true;
        this.video.pause();
        this.status.textContent = '';
        this.video.src = source;
        this.video.preload = 'metadata';
        this.video.load();
      }
      syncPlayback() {
        const automatic = this.dataset.autoplay === 'true' && !this.reduced.matches;
        if (this.visible && !document.hidden && !this.userPaused && (automatic || this.manual)) {
          this.near = true; this.loadSource(); this.play();
        } else { this.video.pause(); }
      }
      play() {
        const result = this.video.play();
        if (result?.catch) result.catch(() => {});
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.loader?.disconnect();
        this.visibility?.disconnect();
        if (this.video) { this.video.pause(); this.video.removeAttribute('src'); this.video.load(); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-image-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const carousels = new Map();
  const cleanup = section => {
    const state = carousels.get(section);
    if (!state) return;
    state.abort.abort();
    state.observer?.disconnect();
    clearTimeout(state.timeout);
    section.classList.remove('home-reveal-ready', 'home-reveal-visible');
    carousels.delete(section);
  };
  const initCarousel = section => {
    if (carousels.has(section)) return;
    const track = section.querySelector('[data-cic-track]');
    if (!track) return;
    const abort = new AbortController();
    const signal = abort.signal;
    const previous = section.querySelector('[data-cic-previous]');
    const next = section.querySelector('[data-cic-next]');
    const progress = section.querySelector('[data-cic-progress]');
    const state = { abort, observer: null, timeout: null };
    carousels.set(section, state);
    const cardStep = () => {
      const card = track.querySelector('.category-image-carousel__card');
      if (!card) return track.clientWidth;
      const styles = getComputedStyle(track);
      return card.getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0);
    };
    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
      if (progress) {
        const visibleRatio = Math.min(1, track.clientWidth / Math.max(1, track.scrollWidth));
        const thumbWidth = visibleRatio * 100;
        const travel = 100 - thumbWidth;
        const position = maxScroll > 0 ? track.scrollLeft / maxScroll * travel : 0;
        progress.style.width = `${thumbWidth}%`;
        progress.style.transform = `translateX(${position / Math.max(visibleRatio, .01)}%)`;
      }
    };
    previous?.addEventListener('click', () => track.scrollBy({ left: -cardStep(), behavior: 'smooth' }), { signal });
    next?.addEventListener('click', () => track.scrollBy({ left: cardStep(), behavior: 'smooth' }), { signal });
    track.addEventListener('scroll', updateControls, { passive: true, signal });
    window.addEventListener('resize', updateControls, { signal });
    updateControls();
    if (section.hasAttribute('data-home-reveal')) {
      const items = [...section.querySelectorAll('.home-reveal-item')];
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (items.length && !reducedMotion && 'IntersectionObserver' in window) {
        section.classList.add('home-reveal-ready');
        state.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          state.observer.disconnect();
          section.classList.add('home-reveal-visible');
          const maxOrder = items.reduce((maximum, item) => Math.max(maximum, parseFloat(item.style.getPropertyValue('--home-reveal-order')) || 0), 0);
          state.timeout = setTimeout(() => section.classList.remove('home-reveal-ready', 'home-reveal-visible'), 1050 + maxOrder * 120 + 180);
        }, { threshold: 0.24, rootMargin: '0px 0px -12% 0px' });
        state.observer.observe(section);
      }
    }
  };

  const init = (scope = document) => {
    for (const section of carousels.keys()) if (!section.isConnected) cleanup(section);
    scope.querySelectorAll('[data-category-image-carousel]').forEach(initCarousel);
  };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-category-image-carousel]').forEach(cleanup);
  });
  document.addEventListener('shopify:section:reorder', () => window.dispatchEvent(new Event('resize')));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-story-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('customer-story-marquee')) {
  customElements.define('customer-story-marquee', class extends HTMLElement {
    connectedCallback() {
      this._abort?.abort();
      this._abort = new AbortController();
      const options = {signal: this._abort.signal};
      this._track = this.querySelector('[data-csm-track]');
      this._source = this.querySelector('[data-csm-source]');
      this._viewport = this.querySelector('[data-csm-viewport]');
      if (!this._track || !this._source || !this._viewport) return;
      this._manual = this.dataset.autoplay !== 'true';
      this._hover = false;
      this._focus = false;
      this._editing = false;
      this._touches = new Set();
      this._near = !('IntersectionObserver' in window);
      this._reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this._button = this.querySelector('[data-csm-toggle]');
      this._button?.addEventListener('click', () => { this._manual = !this._manual; this._sync(); }, options);
      this._track.addEventListener('pointerover', event => {
        if (event.pointerType === 'touch' || this.dataset.hoverPause !== 'true') return;
        if (event.target.closest('[data-csm-card]')) { this._hover = true; this._sync(); }
      }, options);
      this._track.addEventListener('pointerout', event => {
        if (event.pointerType === 'touch') return;
        const next = event.relatedTarget?.closest?.('[data-csm-card]');
        this._hover = Boolean(next && this.contains(next) && this.dataset.hoverPause === 'true');
        this._sync();
      }, options);
      this.addEventListener('focusin', event => {
        this._focus = Boolean(event.target.closest('[data-csm-card]')) || event.target === this._viewport;
        this._sync();
      }, options);
      this.addEventListener('focusout', event => {
        const next = event.relatedTarget;
        this._focus = Boolean(next && this.contains(next) && (next.closest('[data-csm-card]') || next === this._viewport));
        this._sync();
      }, options);
      this._track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' || !event.target.closest('[data-csm-card]')) return;
        this._touches.add(event.pointerId); this._sync();
      }, {...options, passive: true});
      const endTouch = event => { this._touches.delete(event.pointerId); this._sync(); };
      window.addEventListener('pointerup', endTouch, options);
      window.addEventListener('pointercancel', endTouch, options);
      document.addEventListener('visibilitychange', () => this._sync(), options);
      this._reduced.addEventListener('change', () => this._schedule(), options);
      window.addEventListener('resize', () => this._schedule(), {...options, passive: true});
      if ('ResizeObserver' in window) {
        this._resizeObserver = new ResizeObserver(() => this._schedule());
        this._resizeObserver.observe(this._viewport);
        this._resizeObserver.observe(this._source);
      }
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          this._near = entries[0].isIntersecting;
          if (this._near) this._schedule();
          this._sync();
        }, {rootMargin: '120px 0px'});
        this._observer.observe(this);
      }
      document.addEventListener('shopify:block:select', event => {
        const card = [...this._source.children].find(element => element.dataset.csmBlock === event.detail?.blockId);
        if (!card) return;
        this._editing = true;
        this._build();
        if (this._animation && this._cycle > 0) {
          const travel = Math.max(0, Math.min(this._cycle - card.offsetWidth, card.offsetLeft - (this._viewport.clientWidth - card.offsetWidth) / 2));
          const phase = this.dataset.direction === 'right' ? 1 - travel / this._cycle : travel / this._cycle;
          this._animation.currentTime = Math.min(this._duration - .001, phase * this._duration);
        }
        this._sync();
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (![...this._source.children].some(element => element.dataset.csmBlock === event.detail?.blockId)) return;
        this._editing = false; this._sync();
      }, options);
      this._schedule();
    }
    _schedule() {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => { this._frame = 0; this._build(); });
    }
    _removeCopies() {
      this.querySelectorAll('[data-csm-copy]').forEach(copy => copy.remove());
    }
    _build() {
      if (!this._source || !this.isConnected) return;
      if (this._reduced.matches || typeof this._track.animate !== 'function') {
        this._animation?.cancel(); this._animation = null;
        this._removeCopies(); this.removeAttribute('data-csm-ready'); this._sync(); return;
      }
      if (!this._near) return;
      const width = this._source.getBoundingClientRect().width;
      const viewportWidth = this._viewport.clientWidth;
      if (!(width > 0 && viewportWidth > 0)) return;
      const copies = Math.max(1, Math.ceil(viewportWidth / width));
      if (this._animation && width === this._cycle && copies === this._copies) { this._sync(); return; }
      const phase = this._duration ? (Number(this._animation?.currentTime) || 0) % this._duration / this._duration : 0;
      this._animation?.cancel(); this._removeCopies();
      for (let index = 0; index < copies; index++) {
        const copy = this._source.cloneNode(true);
        copy.removeAttribute('data-csm-source'); copy.setAttribute('data-csm-copy', ''); copy.setAttribute('aria-hidden', 'true');
        for (const element of [copy, ...copy.querySelectorAll('*')]) {
          for (const attribute of [...element.attributes]) if (attribute.name === 'id' || attribute.name === 'data-csm-block' || attribute.name.startsWith('data-shopify-editor')) element.removeAttribute(attribute.name);
          if (element.matches('a,button,input,select,textarea,[tabindex]')) element.setAttribute('tabindex', '-1');
        }
        this._track.append(copy);
      }
      this._cycle = width; this._copies = copies;
      this._duration = width / Math.max(1, Number(this.dataset.speed) || 40) * 1000;
      const start = this.dataset.direction === 'right' ? -width : 0;
      const end = this.dataset.direction === 'right' ? 0 : -width;
      this._animation = this._track.animate([{transform: `translate3d(${start}px,0,0)`}, {transform: `translate3d(${end}px,0,0)`}], {duration: this._duration, iterations: Infinity, easing: 'linear'});
      this._animation.pause(); this._animation.currentTime = phase * this._duration;
      this._viewport.scrollLeft = 0;
      this.setAttribute('data-csm-ready', ''); this._sync();
    }
    _sync() {
      const paused = this._manual || this._hover || this._focus || this._editing || this._touches?.size || !this._near || document.hidden || this._reduced?.matches;
      if (paused) this._animation?.pause();
      else if (this._animation) { this._viewport.scrollLeft = 0; this._animation.play(); }
      this.toggleAttribute('data-csm-paused', Boolean(paused));
      if (this._button) {
        this._button.setAttribute('aria-label', this._manual ? this._button.dataset.playLabel : this._button.dataset.pauseLabel);
        this._button.querySelector('[data-csm-play-icon]').hidden = !this._manual;
        this._button.querySelector('[data-csm-pause-icon]').hidden = this._manual;
      }
    }
    disconnectedCallback() {
      this._abort?.abort(); this._resizeObserver?.disconnect(); this._observer?.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      this._frame = 0; this._animation?.cancel(); this._animation = null;
      this._removeCopies(); this.removeAttribute('data-csm-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-product-customizer"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('lb-seat-customizer')) return;
  class LBSeatCustomizer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-config]');
      if (!data) return;
      this.ready = true;
      this.config = JSON.parse(data.textContent);
      this.q = s => this.querySelector(s);
      this.dialog = this.q('dialog');
      this.abort = new AbortController();
      this.initState();
      this.build();
      this.addEventListener('click', e => this.click(e), {signal: this.abort.signal});
      this.dialog.addEventListener('cancel', e => { if (this.busy) e.preventDefault(); }, {signal: this.abort.signal});
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        this.q('[data-launch]').focus({preventScroll: true});
      }, {signal: this.abort.signal});
      this.render();
      if (this.config.autoOpen && !this.config.designMode) this.open();
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.previousOverflow ?? ''; }
      this.ready = false;
    }
    initState() {
      this.seriesId = null; this.seats = null; this.layout = null; this.color = null; this.warrantyId = null;
      this.quantities = new Map(); this.activeStep = 0; this.openSteps = new Set([0]); this.busy = false; this.cartUncertain = false;
      this.notice = ''; this.imageRevision = 0;
      // ===== 解析贴纸锚点 JSON（新增）=====
      this.stickerAnchors = {};
      try {
        const raw = this.config.stickerAnchors;
        if (typeof raw === 'string' && raw.trim()) this.stickerAnchors = JSON.parse(raw);
        else if (raw && typeof raw === 'object') this.stickerAnchors = raw;
      } catch (e) { this.stickerAnchors = {}; }
      this.config.series.forEach(s => {
        s.options = Array.isArray(s.options) ? s.options : [];
        s.variants = Array.isArray(s.variants) ? s.variants : [];
        s.seatIndex = s.options.indexOf(s.seatOption);
        s.layoutIndex = s.options.indexOf(s.layoutOption);
        s.colorIndex = s.options.indexOf(s.colorOption);
        s.valid = !!s.productId && !s.requiresSellingPlan && s.variantCount <= 250 && s.variantCount === s.variants.length &&
          s.options.length === 3 && s.seatIndex >= 0 && s.layoutIndex >= 0 && s.colorIndex >= 0 &&
          new Set([s.seatIndex,s.layoutIndex,s.colorIndex]).size === 3;
      });
      [...this.config.features, ...this.config.warranties].forEach(a => {
        a.seriesIds = (a.seriesIds || '').split(',').map(x => x.trim()).filter(Boolean);
        a.compatibleIds = (a.compatibleIds || '').split(',').map(x => x.trim()).filter(Boolean);
      });
      this.config.warranties.forEach(w => {
        w.options = Array.isArray(w.options) ? w.options : [];
        w.variants = Array.isArray(w.variants) ? w.variants : [];
        w.durationIndex = w.options.indexOf(w.durationOption);
        w.seatIndex = w.options.indexOf(w.seatOption);
        w.valid = w.included || (!!w.productId && !w.requiresSellingPlan && w.variantCount <= 250 &&
          w.variantCount === w.variants.length && w.durationIndex >= 0 && w.seatIndex >= 0 &&
          w.durationIndex !== w.seatIndex && !!w.durationValue);
      });
      this.setupValid = this.config.series.length === 4 && this.config.series.every(s => s.valid) &&
        new Set(this.config.series.map(s => s.productId)).size === 4 && this.config.warranties.some(w => w.valid);
    }
    t(key, vars = {}) {
      let value = this.config.text[key] || key;
      Object.entries(vars).forEach(([k,v]) => { value = value.replaceAll('{' + k + '}', String(v)); });
      return value;
    }
    el(tag, cls, text) { const e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; }
    money(cents) { return new Intl.NumberFormat(this.config.locale || 'en', {style:'currency',currency:this.config.currency,currencyDisplay:'code'}).format(cents / 100); }
    series() { return this.config.series.find(s => s.id === this.seriesId); }
    usable(v) { return v.available && !v.requiresSellingPlan && v.min === 1 && v.increment === 1 && (v.max === null || v.max >= 1); }
    seatValue(v, s = this.series()) { const value = v.options[s.seatIndex]; return /^[1-6]$/.test(value) ? Number(value) : null; }
    candidates(seats = this.seats, layout = this.layout, s = this.series()) {
      return s?.valid ? s.variants.filter(v => this.usable(v) && this.seatValue(v,s) !== null &&
        (seats === null || this.seatValue(v,s) === seats) && (layout === null || v.options[s.layoutIndex] === layout)) : [];
    }
    variant() { return this.color === null ? null : this.candidates().find(v => v.options[this.series().colorIndex] === this.color); }
    compatible(a) {
      const s = this.series(), v = this.variant();
      return !!s && (!a.seriesIds.length || a.seriesIds.includes(String(s.productId))) &&
        (!a.compatibleIds.length || (!!v && a.compatibleIds.includes(String(v.id))));
    }
    purchasable(a) { return a.included || (!!a.variantId && a.available && a.min === 1 && a.increment === 1 && (a.max === null || a.max >= 1)); }
    warrantySeatValue(v,w) {
      const match = String(v?.options?.[w.seatIndex] || '').match(/\b([1-6])\b/);
      return match ? Number(match[1]) : null;
    }
    warrantyOption(w) {
      if (!w || !w.valid || !this.compatible(w) || !this.seats) return null;
      if (w.included) return {...w, variantId:null, price:0, available:true, min:1, increment:1, max:null};
      const v = w.variants.find(x => x.options[w.durationIndex] === w.durationValue && this.warrantySeatValue(x,w) === this.seats);
      if (!v || !this.usable(v)) return null;
      return {...w, variantId:v.id, price:v.price, available:v.available, min:v.min, increment:v.increment, max:v.max};
    }
    cap(a) {
      if (!this.seats || !this.compatible(a) || !this.purchasable(a)) return 0;
      return Math.max(0, Math.min(this.seats, a.max === null ? 6 : a.max, a.stock === null ? 6 : a.stock));
    }
    warranty() { return this.warrantyOption(this.config.warranties.find(w => w.id === this.warrantyId)); }
    selectedFeatures() { return this.config.features.filter(a => (this.quantities.get(a.id) || 0) > 0); }
    total() { return (this.variant()?.price || 0) + (this.warranty()?.price || 0) + this.selectedFeatures().reduce((n,a) => n + a.price * this.quantities.get(a.id), 0); }
    complete() { return this.setupValid && !!this.variant() && !!this.warranty(); }
    setSeries(id) {
      const s = this.config.series.find(x => x.id === id);
      if (!s || !s.valid || !this.candidates(null,null,s).length || id === this.seriesId) return;
      this.seriesId = id; this.seats = null; this.layout = null; this.color = null; this.warrantyId = null;
      this.quantities.clear(); this.notice = this.t('series_reset');
    }
    setSeats(count) {
      if (!Number.isInteger(count) || !this.candidates(count,null).length || count === this.seats) return;
      this.seats = count; this.layout = null; this.color = null;
      this.reconcile();
    }
    setLayout(layout) {
      if (!this.seats || !this.candidates(this.seats,layout).length || layout === this.layout) return;
      this.layout = layout; this.color = null; this.reconcile();
    }
    setColor(color) {
      if (!this.seats || !this.layout || !this.candidates().some(v => v.options[this.series().colorIndex] === color)) return;
      this.color = color; this.reconcile();
    }
    reconcile() {
      let changed = false;
      this.config.features.forEach(a => {
        const old = this.quantities.get(a.id) || 0, next = Math.min(old, this.cap(a));
        if (old !== next) changed = true;
        if (next) this.quantities.set(a.id,next); else this.quantities.delete(a.id);
      });
      if (this.warrantyId && !this.warranty()) { this.warrantyId = null; changed = true; }
      this.notice = changed ? this.t('adjusted') : '';
    }
    setQuantity(id, next) {
      const a = this.config.features.find(x => x.id === id);
      if (!a || !this.variant() || !Number.isInteger(next)) return;
      next = Math.max(0, Math.min(next, this.cap(a)));
      if (next) this.quantities.set(id,next); else this.quantities.delete(id);
    }
    setWarranty(id) {
      const w = this.config.warranties.find(x => x.id === id);
      if (this.variant() && this.warrantyOption(w)) this.warrantyId = id;
    }
    accessibleStep() { return !this.seriesId ? 0 : !this.seats ? 1 : !this.layout ? 2 : !this.variant() ? 3 : !this.warranty() ? 4 : 5; }
    build() {
      this.steps = ['series','seats','layout','color','warranty','features'].map((type,i) => {
        const root = this.el('div','lb-step'), h = this.el('h2','lb-step-heading');
        const toggle = this.el('button','lb-step-toggle'); toggle.type = 'button'; toggle.dataset.step = i;
        const label = this.config.titles[i], body = this.el('div','lb-step-body');
        const clip = this.el('div','lb-step-content'), content = this.el('div','lb-step-inner');
        body.id = `${this.id}-panel-${i}`; toggle.id = `${body.id}-toggle`;
        toggle.setAttribute('aria-controls',body.id); body.setAttribute('role','region'); body.setAttribute('aria-labelledby',toggle.id);
        toggle.append(this.el('span','',`${String(i+1).padStart(2,'0')}. ${label}`),this.el('span','lb-symbol','+'));
        clip.append(content); body.append(clip); h.append(toggle); root.append(h,body); this.q('[data-steps]').append(root);
return {type,body,content,toggle};
      });
    }
    visual(url, title) {
      const el = this.el('span','lb-choice-visual lb-product-thumb');
      if (url) { const img = this.el('img'); img.src = url; img.alt = ''; img.loading = 'lazy'; img.addEventListener('error',()=>{img.remove();el.textContent=title;},{once:true});el.append(img); }
      else el.append(this.el('span','lb-choice-textonly',title));
      return el;
    }
    choice(grid, kind, id, title, url, pressed, disabled, price) {
      const b = this.el('button','lb-choice'); b.type='button'; b.dataset[kind]=String(id);
      b.setAttribute('aria-pressed',String(pressed)); b.disabled = disabled || this.busy;
      b.append(this.visual(url,title),this.el('span','',title));
      if (price !== undefined) b.append(this.el('span','lb-addon-price',price)); grid.append(b); return b;
    }
    renderChoices() {
      const s=this.series(), v=this.variant();
      this.steps.forEach(step => {
        step.content.replaceChildren(); const grid=this.el('div','lb-choice-grid'); step.content.append(grid);
        if (step.type === 'series') {
          this.config.series.forEach(a=>this.choice(grid,'series',a.id,a.title,a.image,this.seriesId===a.id,!a.valid||!this.candidates(null,null,a).length));
        } else if (step.type === 'seats') {
          for (let n=1;n<=6;n++) {
            const example=this.candidates(n,null)[0];
            this.choice(grid,'seats',n,this.t('seat_count',{n}),example?.image,this.seats===n,!example);
          }
        } else if (step.type === 'layout') {
          if (!s || !this.seats) { grid.append(this.el('p','lb-hint',this.t('choose_previous'))); return; }
          const values=[...new Set(this.candidates(this.seats,null).map(a=>a.options[s.layoutIndex]))];
          values.forEach(layout=>{const example=this.candidates(this.seats,layout)[0];this.choice(grid,'layout',layout,layout,example?.image,this.layout===layout,false);});
        } else if (step.type === 'color') {
          if (!s || !this.seats || !this.layout) { grid.append(this.el('p','lb-hint',this.t('choose_previous'))); return; }
          const values=[...new Set(this.candidates().map(a=>a.options[s.colorIndex]))];
          values.forEach(color=>{const example=this.candidates().find(a=>a.options[s.colorIndex]===color);this.choice(grid,'color',color,color,example.image,this.color===color,false);});
        } else if (step.type === 'warranty') {
          const options=this.config.warranties.filter(a=>this.compatible(a));
          options.forEach(a=>{const resolved=this.warrantyOption(a);this.choice(grid,'warranty',a.id,a.title,a.image,this.warrantyId===a.id,!v||!resolved,a.included?this.t('included'):(resolved?`+ ${this.money(resolved.price)}`:''));});
          if (!options.some(a=>this.warrantyOption(a))) step.content.append(this.el('p','lb-hint',this.t('no_warranty')));
        } else {
          grid.classList.add('lb-feature-grid');
          step.content.prepend(this.el('p','lb-hint',this.t('feature_hint',{n:this.seats||0})));
          const options=this.config.features.filter(a=>this.compatible(a));
          options.forEach(a=>{
            const card=this.el('div','lb-feature-card'), qty=this.quantities.get(a.id)||0, cap=this.cap(a);
            this.choice(card,'feature',a.id,a.title,a.image,qty>0,!v||!cap,`${this.money(a.price)} ${this.t('per_seat')}`);
            const controls=this.el('div','lb-quantity'); controls.setAttribute('role','group'); controls.setAttribute('aria-label',a.title);
            const minus=this.el('button','', '−'), plus=this.el('button','', '+'), out=this.el('output','',String(qty));
            minus.type=plus.type='button'; minus.dataset.minus=plus.dataset.plus=a.id;
            minus.setAttribute('aria-label',this.t('decrease',{name:a.title})); plus.setAttribute('aria-label',this.t('increase',{name:a.title}));
            out.setAttribute('aria-label',this.t('installed_seats')); out.setAttribute('aria-live','polite');
            minus.disabled=this.busy||qty===0;plus.disabled=this.busy||!v||qty>=cap;
            controls.append(minus,out,plus);card.append(controls,this.el('small','lb-feature-subtotal',`${qty} / ${this.seats||0} · ${this.money(a.price*qty)}`));
            if (qty && a.description) card.append(this.el('p','lb-feature-description',a.description));
            if (!cap) card.append(this.el('small','',this.t('unavailable')));
            grid.append(card);
          });
          if (!options.length) step.content.append(this.el('p','lb-hint',this.t('no_features')));
          const review=this.el('dl','lb-review');
          const row=(key,val)=>{const d=this.el('div','lb-review-row');d.append(this.el('dt','',key),this.el('dd','',val));review.append(d);};
          if (s) row(this.config.titles[0],s.title);
          if (this.seats) row(this.config.titles[1],String(this.seats));
          if (this.layout) row(this.config.titles[2],this.layout);
          if (this.color) row(this.config.titles[3],this.color);
          if (this.warranty()) row(this.config.titles[4],this.warranty().title);
          this.selectedFeatures().forEach(a=>row(`${a.title} × ${this.quantities.get(a.id)}`,this.money(a.price*this.quantities.get(a.id))));
          step.content.append(review,this.el('p','lb-review-total',`${this.t('subtotal')}: ${this.money(this.total())}`),this.el('p','lb-price-note',this.config.priceNote));
        }
      });
    }
    focusKey() {
      const b=document.activeElement;
      if (!b || !this.contains(b)) return null;
      for (const key of ['series','seats','layout','color','warranty','feature','minus','plus']) if (b.dataset[key] !== undefined) return {key,value:b.dataset[key]};
      return null;
    }
    render() {
      const focus=this.focusKey(), host=this.q('[data-steps]'), scroll=host.scrollTop;
      this.renderChoices();
      const accessible=this.accessibleStep();
this.activeStep=Math.min(this.activeStep,accessible);
this.openSteps=new Set([...this.openSteps].filter(i=>i<=accessible));
this.steps.forEach((s,i)=>{
  const open=this.openSteps.has(i);
  s.body.classList.toggle('is-open',open);
  s.body.setAttribute('aria-hidden',String(!open));
  s.body.inert=!open;
  s.toggle.disabled=this.busy||i>accessible;
  s.toggle.setAttribute('aria-expanded',String(open));
  s.toggle.querySelector('.lb-symbol').textContent=open?'−':'+';
});
      this.q('[data-prev]').disabled=this.busy||this.activeStep===0;
      this.q('[data-next]').disabled=this.busy||this.activeStep===5||this.activeStep>=this.accessibleStep();
      this.q('[data-progress]').textContent=`${this.activeStep+1}/6`;
      const s=this.series(), v=this.variant();
      this.q('[data-product-title]').textContent=s?.title||this.config.title;
      const summary=[s?.title,this.seats?this.t('seat_count',{n:this.seats}):'',this.layout,this.color,this.warranty()?.title].filter(Boolean).join(' / ');
      this.q('[data-configuration]').textContent=summary;
      this.q('[data-preview-caption]').textContent=summary;
      this.q('[data-total]').textContent=v?this.money(this.total()):this.t('choose_price');
      const add=this.q('[data-add]');add.disabled=this.busy||this.cartUncertain||!this.complete()||this.activeStep!==5;add.textContent=this.busy?this.t('adding'):this.config.addLabel;
      this.q('[data-close]').disabled=this.busy;this.q('.lb-panel').setAttribute('aria-busy',String(this.busy));
      const notice=this.q('[data-notice]');notice.hidden=!this.notice;notice.textContent=this.notice;
      const setup=this.q('[data-setup]');setup.hidden=this.setupValid;setup.textContent=this.config.designMode?this.t('setup_admin'):this.t('setup_customer');
      this.renderPreview();
      this.renderStickers();
      host.scrollTop=scroll;
      if (focus) {
        const button=Array.from(this.querySelectorAll(`[data-${focus.key}]`)).find(b=>b.dataset[focus.key]===focus.value);
        if (button && !button.disabled) button.focus({preventScroll:true});
        else this.steps[this.activeStep].toggle.focus({preventScroll:true});
      }
    }
    renderPreview() {
      const s=this.series(), v=this.variant();
      const example=v||(this.seats?this.candidates(this.seats,this.layout)[0]:null);
      const url=example?.image||s?.image||this.config.baseImage;
      if (url===this.previewUrl) return;
      this.previewUrl=url;const rev=++this.imageRevision, stage=this.q('[data-stage]'), error=this.q('[data-preview-error]');
      stage.replaceChildren();error.hidden=true;
      if (!url) {error.hidden=false;return;}
      stage.setAttribute('aria-busy','true');
      const img=this.el('img');img.alt=[s?.title,example?.options.join(' / ')].filter(Boolean).join(' · ');
      img.onload=()=>{if(rev===this.imageRevision){stage.replaceChildren(img);stage.setAttribute('aria-busy','false');this.renderStickers();}};
      img.onerror=()=>{if(rev===this.imageRevision){error.hidden=false;stage.setAttribute('aria-busy','false');}};
      img.src=url;
    }
    /* ===== 新增：渲染贴纸标注（用功能图本身当贴纸）===== */
    renderStickers() {
      const stage = this.q('[data-stage]');
      stage.querySelectorAll('.lb-sticker').forEach(el => el.remove());
      if (!this.seats) return;
      // 取座位锚点：优先按系列名称查，再按 layout 细分，最后回退到全局
      const s = this.series();
      const seriesKey = s?.title || 'default';
      const seatsKey = String(this.seats);
      const layoutKey = this.layout || 'default';
      let seatAnchors = null;
      if (this.stickerAnchors[seriesKey]?.[layoutKey]?.[seatsKey]) {
        seatAnchors = this.stickerAnchors[seriesKey][layoutKey][seatsKey];
      } else if (Array.isArray(this.stickerAnchors[seriesKey]?.[seatsKey])) {
        seatAnchors = this.stickerAnchors[seriesKey][seatsKey];
      } else if (Array.isArray(this.stickerAnchors[seatsKey])) {
        seatAnchors = this.stickerAnchors[seatsKey];
      } else if (Array.isArray(this.stickerAnchors.default?.[seatsKey])) {
        seatAnchors = this.stickerAnchors.default[seatsKey];
      }
      // 功能单独配置
      const featOverrides = this.stickerAnchors[seriesKey]?.features || {};
      if (!seatAnchors && !Object.keys(featOverrides).length) return;
      // 4 个功能循环用色（仅用于底部小圆点区分）
      const palette = ['#ef4444','#f59e0b','#10b981','#6366f1','#ec4899','#06b6d4','#8b5cf6','#14b8a6'];
      this.config.features.forEach((f, fi) => {
        const qty = this.quantities.get(f.id) || 0;
        if (!qty || !f.image) return;
        const color = palette[fi % palette.length];
        const ov = featOverrides[f.title];
        if (ov && typeof ov.x === 'number') {
          // 单次标识模式：只放一个
          this.appendSticker(stage, f.image, f.title, ov, color);
        } else if (Array.isArray(ov)) {
          for (let i = 0; i < qty && i < ov.length; i++) {
            this.appendSticker(stage, f.image, f.title, ov[i], color);
          }
        } else if (seatAnchors) {
          for (let i = 0; i < qty && i < seatAnchors.length; i++) {
            this.appendSticker(stage, f.image, f.title, seatAnchors[i], color);
          }
        }
      });
    }
    appendSticker(stage, src, alt, p, color) {
      const st = this.el('div','lb-sticker');
      st.style.left = p.x + '%';
      st.style.top  = p.y + '%';
      st.style.transform = `translate(-50%, -100%) rotate(${p.rot||0}deg) skewX(${p.skX||0}deg) skewY(${p.skY||0}deg)`;
      const img = this.el('img');
      img.src = src; img.alt = alt; img.loading = 'lazy';
      img.style.width = (p.w || 110) + 'px';
      img.style.height = (p.h || p.w || 110) + 'px';
      const dot = this.el('div','lb-sticker-dot');
      dot.style.background = color;
      st.append(img, dot);
      stage.appendChild(st);
    }
    open() {if(this.dialog.open)return;this.previousOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';this.q('[data-close]').focus({preventScroll:true});}
    click(event) {
      const b=event.target.closest('button');if(!b||!this.contains(b)||b.disabled)return;
      if(b.hasAttribute('data-launch'))return this.open();if(this.busy)return;
      if(b.hasAttribute('data-close'))return this.dialog.close();
      if(b.hasAttribute('data-add'))return this.addToCart();
      let navigation=false;
      if(b.dataset.step!==undefined){
  const target=Math.min(Number(b.dataset.step),this.accessibleStep());
  this.activeStep=target;
  if(this.openSteps.has(target)){
    this.openSteps.delete(target);
  }else{
    this.openSteps.add(target);
  }
  navigation=true;
}
else if(b.hasAttribute('data-prev')){
  this.activeStep=Math.max(0,this.activeStep-1);
  this.openSteps.add(this.activeStep);
  navigation=true;
}
else if(b.hasAttribute('data-next')){
  this.activeStep=Math.min(5,this.accessibleStep(),this.activeStep+1);
  this.openSteps.add(this.activeStep);
  navigation=true;
}
      else if(b.dataset.series!==undefined)this.setSeries(b.dataset.series);
      else if(b.dataset.seats!==undefined)this.setSeats(Number(b.dataset.seats));
      else if(b.dataset.layout!==undefined)this.setLayout(b.dataset.layout);
      else if(b.dataset.color!==undefined)this.setColor(b.dataset.color);
      else if(b.dataset.warranty!==undefined)this.setWarranty(b.dataset.warranty);
      else if(b.dataset.feature!==undefined)this.setQuantity(b.dataset.feature,this.quantities.get(b.dataset.feature)?0:1);
      else if(b.dataset.plus!==undefined)this.setQuantity(b.dataset.plus,(this.quantities.get(b.dataset.plus)||0)+1);
      else if(b.dataset.minus!==undefined)this.setQuantity(b.dataset.minus,(this.quantities.get(b.dataset.minus)||0)-1);
            const selectedStep = [
        'series',
        'seats',
        'layout',
        'color',
        'warranty'
      ].findIndex(key => b.dataset[key] !== undefined);

      if (selectedStep !== -1) {
        const nextStep = Math.min(
          selectedStep + 1,
          this.accessibleStep()
        );

        this.openSteps.add(selectedStep);
        this.openSteps.add(nextStep);
        this.activeStep = nextStep;
        navigation = true;
      }

      this.render();
    }

    cartItems() {
      if(!this.complete())throw new Error(this.t('choose_previous'));
      for(const a of this.selectedFeatures()){const n=this.quantities.get(a.id);if(!Number.isInteger(n)||n<1||n>this.cap(a))throw new Error(this.t('adjusted'));}
      const group=globalThis.crypto?.randomUUID?.()||`lb-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const props={_lb_configuration:group,Series:this.series().title,'Seat count':String(this.seats),Layout:this.layout,Color:this.color,Warranty:this.warranty().title};
      const features=this.selectedFeatures();if(features.length)props['Installed features']=features.map(a=>`${a.title} × ${this.quantities.get(a.id)} ${this.t('seats_word')}`).join('; ');
      const items=[{id:this.variant().id,quantity:1,properties:props}];
      if(!this.warranty().included)items.push({id:this.warranty().variantId,quantity:1,properties:{_lb_configuration:group,'For series':this.series().title,Warranty:this.warranty().title,'Seat count':String(this.seats)}});
      features.forEach(a=>items.push({id:a.variantId,quantity:this.quantities.get(a.id),properties:{_lb_configuration:group,'For series':this.series().title,Feature:a.title,'Total seats':String(this.seats)}}));
      return items;
    }
    async addToCart() {
      if(this.busy||this.cartUncertain||!this.complete()||this.activeStep!==5)return;
      let items;try{items=this.cartItems();}catch(e){this.notice=e.message;this.render();return;}
      this.busy=true;this.q('[data-error]').hidden=true;this.q('[data-cart-link]').hidden=true;this.render();
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
      try{
        const response=await fetch(this.config.cartAddUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items}),signal:controller.signal});
        const result=await response.json();if(!response.ok||result.status)throw new Error(typeof result.description==='string'?result.description:this.t('cart_failed'));
        window.location.assign(this.config.cartUrl);
      }catch(e){this.cartUncertain=true;const error=this.q('[data-error]');error.hidden=false;error.textContent=(e.name==='AbortError'?this.t('timeout'):e.message)+' '+this.t('check_before_retry');this.q('[data-cart-link]').hidden=false;}
      finally{clearTimeout(timer);this.busy=false;this.render();}
    }
  }
  customElements.define('lb-seat-customizer',LBSeatCustomizer);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-3d-feature-viewer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initViewers = (scope = document) => {
      scope.querySelectorAll('[data-p3d-viewer]').forEach((section) => {
        if (section.dataset.p3dBound === 'true') return;
        section.dataset.p3dBound = 'true';

        const model = section.querySelector('model-viewer');
        const options = Array.from(section.querySelectorAll('.p3d__option'));

        options.forEach((option) => {
          option.addEventListener('click', () => {
            options.forEach((item) => {
              const active = item === option;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-selected', String(active));
            });

            if (model) {
              model.setAttribute('camera-orbit', option.dataset.cameraOrbit);
              model.setAttribute('auto-rotate-delay', '2500');
            }
          });
        });

        const reveal = () => section.classList.add('is-visible');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!section.classList.contains('p3d--animate') || reduceMotion || !('IntersectionObserver' in window)) {
          reveal();
          return;
        }

        section.classList.add('p3d--animation-ready');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            window.requestAnimationFrame(reveal);
            observer.unobserve(section);
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

        observer.observe(section);
      });
    };

    initViewers();
    document.addEventListener('shopify:section:load', (event) => initViewers(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-image-viewer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initImageViewers = (scope = document) => {
      scope.querySelectorAll('[data-product-image-viewer]').forEach((section) => {
        if (section.dataset.pivBound === 'true') return;
        section.dataset.pivBound = 'true';

        const options = Array.from(section.querySelectorAll('.piv__option'));
        const panels = Array.from(section.querySelectorAll('[data-piv-panel]'));
        const controls = section.querySelector('.piv__controls');
        const media = section.querySelector('.piv__media');
        const videos = Array.from(section.querySelectorAll('.piv__video'));
        const previous = section.querySelector('[data-piv-prev]');
        const next = section.querySelector('[data-piv-next]');
        const mobileClose = section.querySelector('[data-piv-mobile-close]');
        const mobileQuery = window.matchMedia('(max-width: 599px)');
        let videoVisible = false;

        const syncVideos = () => {
          videos.forEach((video) => {
            const active = video.closest('.piv__panel')?.classList.contains('is-active');
            if (active && videoVisible && !document.hidden) {
              if (video.dataset.pivLoaded !== 'true') {
                const source = video.querySelector('source[data-src]');
                if (!source) return;
                source.src = source.dataset.src;
                source.removeAttribute('data-src');
                video.dataset.pivLoaded = 'true';
                video.load();
              }
              const playback = video.play();
              if (playback && typeof playback.catch === 'function') playback.catch(() => {});
            } else {
              video.pause();
            }
          });
        };

        const videoObserver = videos.length && 'IntersectionObserver' in window
          ? new IntersectionObserver((entries) => {
              videoVisible = entries[0].isIntersecting;
              syncVideos();
            }, { threshold: 0.1 })
          : null;
        if (videoObserver) videoObserver.observe(section);
        else if (videos.length) { videoVisible = true; syncVideos(); }
        if (videos.length) document.addEventListener('visibilitychange', syncVideos);
        section.addEventListener('shopify:section:unload', () => {
          videoObserver?.disconnect();
          document.removeEventListener('visibilitychange', syncVideos);
          videos.forEach((video) => video.pause());
        }, { once: true });

        const centerMobileOption = (option, behavior = 'smooth') => {
          if (!mobileQuery.matches || !controls || !option || section.classList.contains('piv--mobile-expanded')) return;

          const controlsRect = controls.getBoundingClientRect();
          const optionRect = option.getBoundingClientRect();
          const targetLeft = controls.scrollLeft
            + optionRect.left
            - controlsRect.left
            - ((controlsRect.width - optionRect.width) / 2);

          controls.scrollTo({ left: Math.max(0, targetLeft), behavior });
        };

        const setMobileExpanded = (expanded) => {
          const shouldExpand = expanded && mobileQuery.matches;
          section.classList.toggle('piv--mobile-expanded', shouldExpand);
          options.forEach((option) => {
            option.setAttribute('aria-expanded', String(shouldExpand && option.classList.contains('is-active')));
          });
        };

        const activate = (target, centerOnMobile = false) => {
          let activeOption = null;

          options.forEach((option) => {
            const active = option.dataset.pivTarget === target;
            option.classList.toggle('is-active', active);
            option.setAttribute('aria-selected', String(active));
            option.setAttribute('aria-expanded', String(active && section.classList.contains('piv--mobile-expanded')));
            if (active) activeOption = option;
          });

          panels.forEach((panel) => {
            const active = panel.dataset.pivPanel === target;
            panel.classList.toggle('is-active', active);
            panel.setAttribute('aria-hidden', String(!active));
          });
          syncVideos();

          if (centerOnMobile && activeOption) {
            window.requestAnimationFrame(() => centerMobileOption(activeOption));
          }
        };

        options.forEach((option) => option.addEventListener('click', () => {
          activate(option.dataset.pivTarget);
          setMobileExpanded(true);
        }));

        const move = (direction) => {
          const activeIndex = options.findIndex((option) => option.classList.contains('is-active'));
          const nextIndex = (activeIndex + direction + options.length) % options.length;
          if (options[nextIndex]) activate(options[nextIndex].dataset.pivTarget, true);
        };

        let touchStartX = 0;
        let touchStartY = 0;

        if (media) {
          media.addEventListener('touchstart', (event) => {
            if (!mobileQuery.matches || event.touches.length !== 1) return;
            touchStartX = event.touches[0].clientX;
            touchStartY = event.touches[0].clientY;
          }, { passive: true });

          media.addEventListener('touchend', (event) => {
            if (!mobileQuery.matches || !touchStartX || event.changedTouches.length !== 1) return;

            const distanceX = event.changedTouches[0].clientX - touchStartX;
            const distanceY = event.changedTouches[0].clientY - touchStartY;
            touchStartX = 0;
            touchStartY = 0;

            if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY) * 1.2) return;
            move(distanceX < 0 ? 1 : -1);
          }, { passive: true });
        }

        if (previous) previous.addEventListener('click', () => {
          move(-1);
          setMobileExpanded(true);
        });
        if (next) next.addEventListener('click', () => {
          move(1);
          setMobileExpanded(true);
        });
        if (mobileClose) mobileClose.addEventListener('click', () => {
          setMobileExpanded(false);
          const activeOption = section.querySelector('.piv__option.is-active');
          activeOption?.focus({ preventScroll: true });
          window.requestAnimationFrame(() => centerMobileOption(activeOption));
        });
        mobileQuery.addEventListener('change', (event) => {
          if (!event.matches) setMobileExpanded(false);
        });

        const reveal = () => {
          section.classList.add('is-visible');
          window.setTimeout(() => section.classList.remove('piv--animation-ready'), 3200);
        };
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!section.classList.contains('piv--animate') || reduceMotion || !('IntersectionObserver' in window)) {
          reveal();
        } else {
          section.classList.add('piv--animation-ready');
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              window.requestAnimationFrame(reveal);
              observer.unobserve(section);
            });
          }, { threshold: 0.12, rootMargin: '0px 0px 0px 0px' });
          observer.observe(section);
        }

        section.addEventListener('shopify:block:select', (event) => {
          const option = section.querySelector(`[data-block-id="${event.detail.blockId}"]`);
          if (option) option.click();
        });
      });
    };

    initImageViewers();
    document.addEventListener('shopify:section:load', (event) => initImageViewers(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-advantages-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('service-advantage-grid')) {
    customElements.define('service-advantage-grid', class extends HTMLElement {
      connectedCallback() {
        this._frame = requestAnimationFrame(() => this._setup());
      }
      _setup() {
        if (!this.isConnected || this._video) return;
        this._video = this.querySelector('.svc__video');
        if (!this._video) return;
        this._button = this.querySelector('.svc__playback');
        this._generation = (this._generation || 0) + 1;
        this._cleanups = [];
        this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._wantsPlay = this.dataset.autoplay === 'true' && !this._motion.matches;
        this._inView = false;
        this._ignorePause = false;
        this._pendingPlay = null;
        const listen = (target, type, handler) => {
          target.addEventListener(type, handler);
          this._cleanups.push(() => target.removeEventListener(type, handler));
        };
        this._updateButton = () => {
          if (!this._button) return;
          const playing = !this._video.paused && !this._video.ended;
          const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
          this._button.classList.toggle('is-playing', playing);
          this._button.setAttribute('aria-label', label);
          this._button.title = label;
        };
        if (this._button) {
          this._button.hidden = this.dataset.nativeControls === 'true';
          listen(this._button, 'click', () => {
            if (this._video.paused || this._video.ended) {
              this._wantsPlay = true;
              this._sync();
            } else {
              this._wantsPlay = false;
              this._video.pause();
            }
          });
        }
        listen(this._video, 'play', () => {
          this._wantsPlay = true;
          this._updateButton();
          if (!this._inView || document.hidden) this._sync();
        });
        listen(this._video, 'pause', () => {
          if (this._ignorePause) this._ignorePause = false;
          else this._wantsPlay = false;
          this._updateButton();
        });
        listen(this._video, 'ended', () => {
          if (!this._video.loop) this._wantsPlay = false;
          this._updateButton();
        });
        listen(this._video, 'error', () => {
          this._wantsPlay = false;
          if (this._button) this._button.hidden = true;
        });
        listen(document, 'visibilitychange', () => this._sync());
        const motionChanged = () => {
          if (this._motion.matches) {
            this._wantsPlay = false;
            this._sync();
          }
        };
        if (this._motion.addEventListener) listen(this._motion, 'change', motionChanged);
        else {
          this._motion.addListener(motionChanged);
          this._cleanups.push(() => this._motion.removeListener(motionChanged));
        }
        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver(entries => {
            const entry = entries[entries.length - 1];
            this._inView = entry.isIntersecting && entry.intersectionRatio >= .1;
            this._sync();
          }, { threshold: [0, .1] });
          this._observer.observe(this.querySelector('.svc__media'));
        } else {
          this._inView = true;
          this._sync();
        }
        this._updateButton();
      }
      _sync() {
        if (!this._video || !this.isConnected) return;
        const play = this._wantsPlay && this._inView && !document.hidden;
        if (play && this._video.paused && !this._pendingPlay) {
          const generation = this._generation;
          try {
            const result = this._video.play();
            if (result && typeof result.then === 'function') {
              this._pendingPlay = result.catch(() => {}).finally(() => {
                if (generation !== this._generation) return;
                this._pendingPlay = null;
                if (this._video) this._updateButton();
              });
            }
          } catch (_) {
            this._updateButton();
          }
        } else if (!play && !this._video.paused) {
          this._ignorePause = true;
          this._video.pause();
        }
      }
      disconnectedCallback() {
        this._generation = (this._generation || 0) + 1;
        cancelAnimationFrame(this._frame);
        if (this._observer) this._observer.disconnect();
        if (this._cleanups) this._cleanups.forEach(cleanup => cleanup());
        if (this._video) this._video.pause();
        this._video = null;
        this._button = null;
        this._observer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('weilianda-inline-video')) {
  class InlineVideo extends HTMLElement {
    connectedCallback() {
      this._abort?.abort();
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this._videos = [...this.querySelectorAll('video')];
      this._frameRequests ||= new Map();
      this._loop = this.dataset.loop === 'true';
      if (this.dataset.played === 'true') return this._finish();
      this._query = matchMedia('(max-width: 699px)');
      this._visible = false;
      this._query.addEventListener('change', () => this._select(), { signal });
      this._videos.forEach(video => {
        video.controls = false;
        video.removeAttribute('controls');
        video.muted = true;
        video.playsInline = true;
        video.loop = this._loop;
        this._hideFrame(video, true);
        video.addEventListener('playing', () => this._revealFrame(video), { signal });
        video.addEventListener('waiting', () => this._hideFrame(video), { signal });
        video.addEventListener('ended', () => {
          if (video !== this._video) return;
          if (this._loop) {
            try { video.currentTime = 0; } catch { return this._finish(); }
            this._sync();
          } else this._finish();
        }, { signal });
        video.addEventListener('error', () => {
          if (video === this._video) this._finish();
        }, { signal });
      });
      document.addEventListener('visibilitychange', () => this._sync(), { signal });
      this._observer = new IntersectionObserver(entries => {
        this._visible = entries[0].isIntersecting;
        this._sync();
      }, { threshold: 0.01 });
      this._observer.observe(this);
      this._select();
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._observer?.disconnect();
      this._videos?.forEach(video => { video.pause(); this._hideFrame(video, true); });
    }
    _hideFrame(video, reset = false) {
      const pending = this._frameRequests?.get(video);
      if (pending) {
        if (pending.type === 'video') video.cancelVideoFrameCallback?.(pending.id);
        else cancelAnimationFrame(pending.id);
        this._frameRequests.delete(video);
      }
      if (!reset && this._loop && video.dataset.frameReady === 'true') return;
      delete video.dataset.frameReady;
      if (video === this._video) {
        const copy = this.closest('.content-over-media')?.querySelector('[data-video-copy]');
        if (copy) copy.hidden = !this._loop;
      }
    }
    _revealFrame(video) {
      if (video !== this._video || this.dataset.played === 'true') return;
      if (this._loop && video.dataset.frameReady === 'true') return;
      this._hideFrame(video, true);
      const reveal = () => {
        this._frameRequests.delete(video);
        if (video === this._video && this.dataset.played !== 'true' && !video.paused && video.readyState >= 2) {
          video.dataset.frameReady = 'true';
          if (this._loop) video.removeAttribute('poster');
          const copy = this.closest('.content-over-media')?.querySelector('[data-video-copy]');
          if (copy) copy.hidden = false;
        }
      };
      if (typeof video.requestVideoFrameCallback === 'function') {
        this._frameRequests.set(video, { type: 'video', id: video.requestVideoFrameCallback(reveal) });
      } else {
        this._frameRequests.set(video, { type: 'animation', id: requestAnimationFrame(reveal) });
      }
    }
    _select() {
      if (this.dataset.played === 'true') return;
      const desktop = this.querySelector('[data-device="desktop"]');
      const mobile = this.querySelector('[data-device="mobile"]');
      const selected = this._query.matches ? mobile || desktop : desktop || mobile;
      if (selected === this._video) return;
      const time = this._video?.currentTime || 0;
      this._videos.forEach(video => {
        video.pause();
        this._hideFrame(video, true);
        video.hidden = video !== selected;
      });
      this._video = selected;
      if (!selected) return this._finish();
      const seek = () => {
        if (selected !== this._video || this.dataset.played === 'true') return;
        if (time > 0) {
          try { selected.currentTime = Math.min(time, Math.max(0, (selected.duration || time + 1) - 0.05)); } catch {}
        }
        this._sync();
      };
      if (selected.readyState >= 1) seek();
      else {
        selected.addEventListener('loadedmetadata', seek, { once: true, signal: this._abort.signal });
        this._sync();
      }
    }
    _sync() {
      if (this.dataset.played === 'true' || !this._video) return;
      if (!this._visible || document.hidden) {
        this._video.pause();
        return;
      }
      const video = this._video;
      video.play()?.catch(() => {
        if (video === this._video && this._visible && !document.hidden) this._finish();
      });
    }
    _finish() {
      this.dataset.played = 'true';
      this._videos?.forEach(video => { video.pause(); this._hideFrame(video, true); });
      this._observer?.disconnect();
      const copy = this.closest('.content-over-media')?.querySelector('[data-video-copy]');
      if (copy) copy.hidden = !this._loop;
      this.hidden = true;
    }
  }
  customElements.define('weilianda-inline-video', InlineVideo);
}


  } catch(e) { console.error(e); }
})();
})();
